import React, { memo } from "react";
import PropTypes from "prop-types";

import { SwiperBlock } from "../../SwiperBlock";
import { useRouter } from "next/router";
import Link from "next/link";
import Image from "next/image";

const params = {
  centeredSlides: true,
  slidesPerView: 1.3,
  spaceBetween: 23,
  grabCursor: true,

  navigation: {
    nextEl: ".trainer-block-swiper-next-btn",
    prevEl: ".trainer-block-swiper-prev-btn",
  },

  breakpoints: {
    1220: {
      slidesPerView: 4,
      centeredSlides: false,
    },
    920: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    680: {
      slidesPerView: 2,
      centeredSlides: false,
    },
  },
};

const TrainerDesctopBlock = memo(
  ({ allInstructors, scheduleButton, hallsetId, scheduleDefaultView }) => {
    const router = useRouter();
    const {
      query: { club },
    } = router;

    return (
      <div className="club-trainers-block-desctop">
        <SwiperBlock params={params}>
          {allInstructors.map(({ id, name, instructorImage }) => {
            return (
              <div className="club-trainer-slide" key={id}>
                <Link
                  href={{
                    pathname: `${club}/instructor/${id}`,
                    query: { hallsetId, fromClub: true },
                  }}
                  as={`${club}/instructor/${id}`}
                >
                  <div className="club-trainer">
                    {instructorImage && (
                      <Image
                        className="club-trainer__img"
                        src={instructorImage}
                        fill
                        alt={`instructor${id}`}
                      />
                    )}
                    <div className="club-trainer-inner">
                      <h3 className="club-trainer-name">{name}</h3>
                      {/* TODO: востановить кнопку индивидуального занятия */}
                      {/* <button className="club-trainer-button club-trainer-button-first">
                    {individualLesson}
                  </button> */}

                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          const pathname = `/club/${club}/schedule/${scheduleDefaultView}/${hallsetId}`;
                          router.push(
                            {
                              pathname,
                              query: {
                                instructor: id,
                              },
                              // hash: "_instructors",
                            },
                            pathname
                          );
                        }}
                        className="club-trainer-button club-trainer-button-second"
                      >
                        {scheduleButton}
                      </button>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </SwiperBlock>
      </div>
    );
  }
);

TrainerDesctopBlock.propTypes = {
  dispatchInstructor: PropTypes.func,
  matchUrl: PropTypes.string,
  allInstructors: PropTypes.array,
  scheduleButton: PropTypes.string,
  hallsetId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

TrainerDesctopBlock.defaultProps = {
  dispatchInstructor: () => {},
  matchUrl: "",
  allInstructors: [],
  scheduleButton: "",
  hallsetId: null,
};

export default TrainerDesctopBlock;
